<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <div class="z-card z-card--only-desktop" v-if="contentLoaded">
            <z-icon
              :icon="['far', 'check-circle']"
              size="extra-large"
              color="success"
              class="success-icon"
            />

            <div class="z-title z-title--small spacer-bottom-l">
              A mensalidade
              <template v-if="bill">
                de {{ bill.month_name }}
              </template>
              foi paga com sucesso
            </div>

            <div class="z-button-wrapper">
              <router-link
                tag="button"
                :to="{ name: 'panel'}"
                class="z-button z-button--primary z-button--block"
              >
                Voltar para página inicial
              </router-link>

              <router-link
                tag="button"
                :to="{ name: 'payment-receipt', params: { billId: this.billId } }"
                class="z-button z-button--secondary z-button--block"
              >
                Ver comprovante
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.success-icon {
  margin-bottom: var(--space-medium);
}

.z-card--only-desktop {
  @media (max-width: $screen-sm-max) {
    background-color: unset;
    box-shadow: unset;
    padding: unset;
    transition: unset;
  }
}
</style>

<script>
import DashboardService from 'services/DashboardService';

export default {
  data() {
    return {
      bill: null,
      contentLoaded: false,
    };
  },
  computed: {
    billId() {
      return this.$route.params.billId;
    },
  },
  methods: {
    loadPaymentInfo() {
      DashboardService.getBill(this.billId)
        .then((data) => {
          this.bill = data;
          this.validateBill();
        })
        .catch((error) => {
          this.$rollbar.error(error);
        })
        .finally(() => this.contentLoaded = true);
    },
    validateBill() {
      if (this.bill.status !== 'paid') {
        this.$router.push({ name: 'panel' });
      }
    },
  },
  mounted() {
    this.loadPaymentInfo();
  },
};
</script>
